import React, { useEffect } from 'react';
import { getProductEntityName } from '../Product.config';

import { useAssignUserNeedDesignSpec } from '../Product.hooks';
import {
  ProductDesignSpec,
  BaseProductAssignDialogProps
} from '../Product.interface';
import AssignDesignSpecDialog from './AssignDesignSpecDialog';

export type UserNeedAssignDesignSpecDialogProps = BaseProductAssignDialogProps<'userNeedId'>;

const UserNeedAssignDesignSpecDialog: React.FC<UserNeedAssignDesignSpecDialogProps> = (
  props: UserNeedAssignDesignSpecDialogProps
) => {
  const {
    open,
    productId,
    userNeedId,
    selectedItems,
    onCancel,
    onError,
    onAssigned
  } = props;
  const {
    updatedProductUserNeed,
    isAssigning,
    error: assignError,
    assignDesignSpecs
  } = useAssignUserNeedDesignSpec(productId, userNeedId);

  // handle notification to parent after assigning
  useEffect(() => {
    if (updatedProductUserNeed) {
      onAssigned?.(updatedProductUserNeed);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedProductUserNeed]);

  useEffect(() => {
    if (assignError) {
      onError?.(assignError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignError]);

  return (
    <AssignDesignSpecDialog
      {...{ open, productId, selectedItems, onCancel, onError }}
      isLoading={isAssigning}
      contentText={`Search for ${getProductEntityName(
        'designSpec'
      )} to assign to the ${getProductEntityName('userNeed')}.`}
      onSubmit={(designSpecs: ProductDesignSpec[]) => {
        assignDesignSpecs({
          designSpecIds: designSpecs.map(
            (designSpec: ProductDesignSpec) => designSpec.id
          )
        });
      }}
    />
  );
};

export default UserNeedAssignDesignSpecDialog;
